import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import Loader from "@/Layout/Loader";
import { useMenuItems } from "@/Layout/SideBar-Layout/Menu";
import usePermissions from "@/utils/hooks/usePermissions";
import { getFirstMenuLinkPath } from "@/utils/menuNavigation";
import { MAKKAH_HOME_ANALYTICS_PERMISSIONS } from "./dashboardRoutePermissions";

const Dashboard = lazy(() => import("@/Pages/Dashboard"));

export function MakkahHomeRoute() {
  const { hasAnyPermission } = usePermissions();
  const { makkah } = useMenuItems();

  if (!hasAnyPermission(MAKKAH_HOME_ANALYTICS_PERMISSIONS)) {
    const to = getFirstMenuLinkPath(makkah) || "/app/me";
    return <Navigate to={to} replace />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Dashboard />
    </Suspense>
  );
}
